export const REPORT_PAYLOAD_REQUEST = 'REPORT_PAYLOAD_REQUEST';
export const REPORT_PAYLOAD_RESPONSE = 'REPORT_PAYLOAD_RESPONSE';

export type ReportPayloadChannel = 'viewer' | 'designer';

export interface ReportPayloadBase {
  apiUrl?: string;
  apiBaseUrl?: string;
  authHeaders?: Record<string, string>;
  language?: string;
  dateFormat?: string;
  working_period_id?: string | number;
  company?: { id?: number | string };
}

export interface ReportViewerPayload extends ReportPayloadBase {
  currentReport: { content: string } | Record<string, unknown>;
  viewerData?: unknown;
  filter?: object;
  translateFields?: string[];
  dateFields?: string[];
  receipt_design?: boolean;
}

export interface ReportDesignerPayload extends ReportPayloadBase {
  mode: 'add' | 'edit' | 'copy' | string;
  parentModule?: string;
  module?: string;
  key?: string;
  type?: string;
  currentReport?: string;
  sourceData?: Record<string, unknown>;
  designObject?: Record<string, unknown>;
  receipt_design?: boolean;
  showSaveModal?: boolean;
  showRoleAndUsers?: boolean;
  relationData?: boolean;
  relationName?: string;
  relationParent?: string;
  relationChild?: string;
  relationParentID?: string;
  relationChildID?: string;
}

export interface ReportPayloadRequestMessage {
  type: typeof REPORT_PAYLOAD_REQUEST;
  token: string;
  channel: ReportPayloadChannel;
}

export interface ReportPayloadResponseMessage {
  type: typeof REPORT_PAYLOAD_RESPONSE;
  token: string;
  payload: ReportViewerPayload | ReportDesignerPayload;
}
